import WarehouseCURModule from "@/modules/WarehouseCUR";

function EditWarehousePage() {
  return <WarehouseCURModule type="edit" />;
}

export default EditWarehousePage;
